var _g, _g2, _polygon, _path, _circle, _path2, _path3, _path4, _path5, _g3, _g4, _path6, _path7, _path8, _path9, _path10, _path11, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path12, _path13, _path14, _path15, _rect12, _g5, _path16, _path17, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHouseGuy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 476.55479,
    height: 460.21502,
    viewBox: "0 0 476.55479 460.21502",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "220.21397 451.57101 232.07309 451.56985 237.71454 405.82702 220.21159 405.82824 220.21397 451.57101",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.84479,451.302h0c.36926,.62189,.56409,2.62906,.56409,3.35226h0c0,2.22293-1.80203,4.02502-4.02502,4.02502h-36.7263c-1.51648,0-2.7459-1.22934-2.7459-2.74591v-1.52902s-1.8168-4.59555,1.92369-10.2598c0,0,4.64894,4.43521,11.59566-2.51151l2.04852-3.71106,14.82851,10.84482,8.21922,1.01172c1.79819,.22131,3.39246-.03436,4.31744,1.52347h.00009Z",
    fill: "#2f2e41"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "175.21397 451.57101 187.07309 451.56985 192.71454 405.82702 175.21159 405.82824 175.21397 451.57101",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.8448,451.302h0c.36925,.62189,.56409,2.62906,.56409,3.35226h0c0,2.22293-1.80202,4.02502-4.02502,4.02502h-36.7263c-1.51648,0-2.7459-1.22934-2.7459-2.74591v-1.52902s-1.8168-4.59555,1.92369-10.2598c0,0,4.64894,4.43521,11.59566-2.51151l2.04852-3.71106,14.82851,10.84482,8.21921,1.01172c1.7982,.22131,3.39246-.03436,4.31743,1.52347h.00012Z",
    fill: "#2f2e41"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "166.48021 205.85551 151.48021 239.85551 170.48021 425.85553 193.98021 427.35553 203.48021 262.85553 212.48021 427.85553 240.48021 424.85553 247.12193 215.39489 166.48021 205.85551",
    fill: "#2f2e41"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M225.57864,70.35552l-30.09843-5.5-6.07874,6.07874-30.92126,12.92126,5,97.00001s-10,6.66142-5,15.8307,4,20.1693,4,20.1693h84.64174l-3.64172-55,10-70-23.36613-11.0625-4.53543-10.4375h-.00002Z",
    fill: "#2369d1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 212.41896,
    cy: 35.58432,
    r: 26.43324,
    fill: "#ffb6b6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M193.46066,59.04964c-3.16664,.28297-8.33604-7.81783-8.10564-15.66315,.14822-5.04705-4.23354-6.03942-4.55911-12.54824-.1897-3.79259,5.63599-4.97511,6.03616-8.01702,.72507-5.51164,4.28094-9.22043,4.72488-9.6713,3.83215-3.89193,6.53676-2.62671,11.0433-7.13736,2.71317-2.71563,2.01797-3.45962,3.84521-4.66415,5.27354-3.47634,14.74936,.29135,20.41591,5.36658,1.96088,1.75623,9.27003-.16323,12.46283,4.79619,3.76167,5.8431,2.88828,17.7594,1.27522,19.33202-.98001,.95544-3.21809-1.37882-9.284-2.87694-5.61601-1.38702-.31822,5.4722-6.81078,4.32115-7.67747-1.36114-9.18057-3.69693-12.05589-2.29598-3.03947,1.48093-5.41446,6.06658-4.72488,9.6713,.34218,1.78881,1.33388,2.78625,.77461,3.69587-1.021,1.66068-2.19258,.03197-3.50221,1.69859-1.52328,1.9385,2.26202,6.9115,1.54924,7.39175-.14362,.09678-.57838,.08416-4.66415-3.84522-1.63144-1.56899-2.10973-2.53248-2.42889-2.38459-.51669,.2394-3.90344,3.39443-2.61026,5.88597,2.01247,3.87731-.5631,3.9981,0,6.60831,.58093,2.69284-1.36913,.1564-3.38159,.33623h.00003Z",
    fill: "#2f2e41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "b-95",
    d: "M221.55966,187.47883c-7.79353,4.06776-12.01196,11.38629-9.42239,16.34572s11.00543,5.68114,18.80121,1.61087c3.13638-1.58319,5.84802-3.89445,7.90804-6.74046l32.80382-17.65234-8.61185-15.21732-31.42445,19.01768c-3.51389,.06303-6.96155,.96686-10.05438,2.63585h.00002Z",
    fill: "#ffb6b6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M247.48021,92.85552s9.00002-6,15.00002,10c4.73352,12.62267,13.51254,49.82973,17.00784,64.97489,.92789,4.02048-.41492,8.22028-3.49884,10.96156l-4.009,3.56355-19.5,14.5-13.29527-19.34688,16.14764-9.73579-18.41534-39.94857,10.56299-34.96875-.00002-.00002h-.00002Z",
    fill: "#2369d1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M247.83865,175.5899v-20.50708c0-1.18271,.96211-2.14482,2.14468-2.14482h9.9234c1.18256,0,2.14453,.96211,2.14453,2.14482v20.50708c0,1.1824-.96198,2.14453-2.14453,2.14453h-9.92339c-1.18256,0-2.14468-.96211-2.14468-2.14453h-.00002Z",
    fill: "#2369d1"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 389.65041,
    cy: 113.19268,
    r: 29.39259,
    fill: "#ff6884"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.62355,299.58399l-33.21394,.45816-13.31596-148.47769c-.3231-3.60384,.84092-7.24768,3.194-9.99673l32.65964-38.15542c4.5719-5.34074,12.34537-6.30435,18.0825-2.23939l40.90555,28.98227c3.33714,2.36433,5.40513,6.06102,5.67341,10.14209l29.85932,100.31438-4.00486,33.45396,.03924,.04631,4.73302,24.30481-84.61191,1.16725Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.66647,137.93582l-.53482-6.8914c-.14117-1.81903,1.22392-3.41384,3.04295-3.55501l9.68253-.75144c1.81904-.14117,3.41361,1.22393,3.55478,3.04297l.53482,6.8914c.14117,1.81903-1.22369,3.41382-3.04273,3.55499l-9.68253,.75144c-1.81904,.14117-3.41383-1.22392-3.55501-3.04296Z",
    fill: "#2369d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.35125,193.01648l-1.97879-25.49742c-.14117-1.81904,1.22392-3.41383,3.04295-3.555l14.33404-1.11243c1.81904-.14117,3.41361,1.22393,3.55478,3.04297l1.97879,25.49742c.14117,1.81904-1.22369,3.41382-3.04273,3.55499l-14.33404,1.11243c-1.81904,.14117-3.41383-1.22392-3.555-3.04295Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.38401,250.18585c-1.73726,.07313-3.24341-1.22435-3.42923-2.95332l-2.63734-24.58809c-.11254-1.04964,.26698-2.06253,1.04117-2.78021,.77422-.71723,1.81365-1.01725,2.85166-.82636l.73977,.13726c1.47164,.27286,2.58042,1.50521,2.69622,2.99741l1.8976,24.45128c.07008,.90305-.22243,1.77391-.82355,2.45166-.57442,.6478-1.35748,1.03623-2.21601,1.10286-.03997,.0031-.07998,.00575-.12029,.00751Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.04502,249.11942l-1.98454-25.57146c-.1401-1.80518,1.16133-3.36351,2.9626-3.54808l13.00343-1.3286c1.80393-.16513,3.43338,1.1342,3.62678,2.94027l2.7596,25.83074c.09566,.89695-.16904,1.77297-.74584,2.46665-.57635,.69365-1.38914,1.11409-2.28833,1.18387l-13.77872,1.06933c-1.81904,.14117-3.41383-1.22392-3.55499-3.04273Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.40569,260.61678l11.62002,17.36076,2.75658,20.32449,8.17089-.1147-4.66806-23.97122-18.55037-21.95795h0c-1.24336,2.71361-.98934,5.87808,.67094,8.35863Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.84837,
    y: 293.99585,
    width: 33.24407,
    height: 0.46659,
    transform: "translate(-25.03371 39.39135) rotate(-5.22098)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.23182,
    y: 289.87627,
    width: 31.51854,
    height: 0.46656,
    transform: "translate(-23.18761 36.65057) rotate(-4.8853)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.65636,
    y: 285.92536,
    width: 30.15392,
    height: 0.46663,
    transform: "translate(-25.75028 41.69659) rotate(-5.55661)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.6063,
    y: 281.96496,
    width: 28.96796,
    height: 0.46681,
    transform: "translate(-28.61539 47.66925) rotate(-6.33939)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.0565,
    y: 278.32282,
    width: 27.83385,
    height: 0.46683,
    transform: "translate(-28.66995 48.38874) rotate(-6.45117)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.63492,
    y: 274.68258,
    width: 27.09311,
    height: 0.46655,
    transform: "translate(-20.03289 32.79404) rotate(-4.43769)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.75881,
    y: 271.65113,
    width: 26.33203,
    height: 0.46658,
    transform: "translate(-22.57533 37.76306) rotate(-5.10909)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.94093,
    y: 268.74285,
    width: 25.52764,
    height: 0.46681,
    transform: "translate(-27.18837 46.99375) rotate(-6.33939)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.06814,
    y: 265.36226,
    width: 25.19798,
    height: 0.46662,
    transform: "translate(-23.35286 40.06985) rotate(-5.44474)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.03418,
    y: 262.39856,
    width: 24.1352,
    height: 0.46678,
    transform: "translate(-26.08157 45.81999) rotate(-6.2276)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.08159,
    y: 259.36602,
    width: 23.91178,
    height: 0.46658,
    transform: "translate(-21.06576 36.44258) rotate(-4.9972)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.60323,250.73238l-2.44808-31.54437c-.14119-1.81926,1.2239-3.41406,3.04294-3.55523l15.26434-1.18463c1.81904-.14117,3.41361,1.22393,3.5548,3.0432l2.44808,31.54437c.14115,1.81881-1.22371,3.41359-3.04274,3.55476l-15.26434,1.18463c-1.81904,.14117-3.41383-1.22392-3.55499-3.04273Z",
    fill: "#2369d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.62355,299.58399l-27.15431,.37587-.2189,.00282-1.62291-20.91178c-.20524-2.64463,1.77931-4.96339,4.42394-5.16863l26.68937-2.0713c2.64463-.20524,4.96318,1.77955,5.16842,4.42419l1.75761,22.64746-.23258,.01805-8.81064,.68331Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.02363,193.37448l-1.87051-24.10219c-.14117-1.81904,1.22392-3.41383,3.04295-3.555l5.03103-.39045c1.81904-.14117,3.41361,1.22393,3.55478,3.04297l1.87051,24.10219c.14115,1.81881-1.22371,3.41359-3.04274,3.55476l-5.03103,.39045c-1.81904,.14117-3.41383-1.22392-3.55499-3.04273Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.3382,298.60925l-2.98381-20.35832-5.70252-19.21142-1.57802-5.25898h0c-2.51574-1.43949-5.59338,.61778-5.22509,3.49275l.291,2.27162,5.70252,19.21142,2.98381,20.35832",
    fill: "#ccc"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M69.08368,303.33635l-33.21394,.45816-13.31596-148.47769c-.3231-3.60384,.84092-7.24768,3.194-9.99673l32.65964-38.15542c4.5719-5.34074,12.34537-6.30435,18.0825-2.23939l40.90555,28.98227c3.33714,2.36433,5.40513,6.06102,5.67341,10.14209l29.85932,100.31438-4.00486,33.45396,.03924,.04631,4.73302,24.30481-84.61191,1.16725Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1266,141.68819l-.53482-6.8914c-.14117-1.81903,1.22392-3.41384,3.04295-3.55501l9.68253-.75144c1.81904-.14117,3.41361,1.22393,3.55478,3.04297l.53482,6.8914c.14117,1.81903-1.22369,3.41382-3.04273,3.55499l-9.68253,.75144c-1.81904,.14117-3.41383-1.22392-3.55501-3.04296Z",
    fill: "#2369d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.81139,196.76884l-1.97879-25.49742c-.14117-1.81904,1.22392-3.41383,3.04295-3.555l14.33404-1.11243c1.81904-.14117,3.41361,1.22393,3.55478,3.04297l1.97879,25.49742c.14117,1.81904-1.22369,3.41382-3.04273,3.55499l-14.33404,1.11243c-1.81904,.14117-3.41383-1.22392-3.555-3.04295Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.84414,253.93821c-1.73726,.07313-3.24341-1.22435-3.42923-2.95332l-2.63734-24.58809c-.11254-1.04964,.26698-2.06253,1.04117-2.78021,.77422-.71723,1.81365-1.01725,2.85166-.82636l.73977,.13726c1.47164,.27286,2.58042,1.50521,2.69622,2.99741l1.8976,24.45128c.07008,.90305-.22243,1.77391-.82355,2.45166-.57442,.6478-1.35748,1.03623-2.21601,1.10286-.03997,.0031-.07998,.00575-.12029,.00751Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.50516,252.87178l-1.98454-25.57146c-.1401-1.80518,1.16133-3.36351,2.9626-3.54808l13.00343-1.3286c1.80393-.16513,3.43338,1.1342,3.62678,2.94027l2.7596,25.83074c.09566,.89695-.16904,1.77297-.74584,2.46665-.57635,.69365-1.38914,1.11409-2.28833,1.18387l-13.77872,1.06933c-1.81904,.14117-3.41383-1.22392-3.55499-3.04273Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.86582,264.36914l11.62002,17.36076,2.75658,20.32449,8.17089-.1147-4.66806-23.97122-18.55037-21.95795h0c-1.24336,2.71361-.98934,5.87808,.67094,8.35863Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.3085,
    y: 297.74821,
    width: 33.24407,
    height: 0.46659,
    transform: "translate(-26.58472 12.8776) rotate(-5.22098)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.69195,
    y: 293.62864,
    width: 31.51854,
    height: 0.46656,
    transform: "translate(-24.56628 11.83629) rotate(-4.8853)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.11649,
    y: 289.67773,
    width: 30.15392,
    height: 0.46663,
    transform: "translate(-27.48356 13.48466) rotate(-5.55661)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.06643,
    y: 285.71733,
    width: 28.96796,
    height: 0.46681,
    transform: "translate(-30.8124 15.50107) rotate(-6.33939)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.51663,
    y: 282.07518,
    width: 27.83385,
    height: 0.46683,
    transform: "translate(-30.93759 15.65613) rotate(-6.45117)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.09506,
    y: 278.43494,
    width: 27.09311,
    height: 0.46655,
    transform: "translate(-21.19724 10.24743) rotate(-4.43769)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.21894,
    y: 275.40349,
    width: 26.33203,
    height: 0.46658,
    transform: "translate(-24.06779 11.81568) rotate(-5.10909)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.40107,
    y: 272.49521,
    width: 25.52764,
    height: 0.46681,
    transform: "translate(-29.38538 14.82556) rotate(-6.33939)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.52828,
    y: 269.11462,
    width: 25.19798,
    height: 0.46662,
    transform: "translate(-25.02429 12.42383) rotate(-5.44474)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.49431,
    y: 266.15092,
    width: 24.1352,
    height: 0.46678,
    transform: "translate(-28.20904 14.21641) rotate(-6.2276)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.54173,
    y: 263.11838,
    width: 23.91178,
    height: 0.46658,
    transform: "translate(-22.50077 11.06167) rotate(-4.9972)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.06336,254.48474l-2.44808-31.54437c-.14119-1.81926,1.2239-3.41406,3.04294-3.55523l15.26434-1.18463c1.81904-.14117,3.41361,1.22393,3.5548,3.0432l2.44808,31.54437c.14115,1.81881-1.22371,3.41359-3.04274,3.55476l-15.26434,1.18463c-1.81904,.14117-3.41383-1.22392-3.55499-3.04273Z",
    fill: "#2369d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.08368,303.33635l-27.15431,.37587-.2189,.00282-1.62291-20.91178c-.20524-2.64463,1.77931-4.96339,4.42394-5.16863l26.68937-2.0713c2.64463-.20524,4.96318,1.77955,5.16842,4.42419l1.75761,22.64746-.23258,.01805-8.81064,.68331Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.48377,197.12684l-1.87051-24.10219c-.14117-1.81904,1.22392-3.41383,3.04295-3.555l5.03103-.39045c1.81904-.14117,3.41361,1.22393,3.55478,3.04297l1.87051,24.10219c.14115,1.81881-1.22371,3.41359-3.04274,3.55476l-5.03103,.39045c-1.81904,.14117-3.41383-1.22392-3.55499-3.04273Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.79834,302.36162l-2.98381-20.35832-5.70252-19.21142-1.57802-5.25898h0c-2.51574-1.43949-5.59338,.61778-5.22509,3.49275l.291,2.27162,5.70252,19.21142,2.98381,20.35832",
    fill: "#ccc"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M244.22308,301.13031l-33.21326,.45811-13.31619-148.47767c-.3231-3.60384,.84092-7.24768,3.194-9.99673l32.65986-38.15544c4.57162-5.34141,12.34516-6.30411,18.08227-2.23937l40.90553,28.98227c3.33714,2.36433,21.29006,15.78192,21.55834,19.86299l-8.53127,102.14826,18.5008,21.89919,.03924,.04631,4.73302,24.30481-84.61237,1.16729h.00001Z",
    fill: "#e6e6e6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M237.26642,139.48211l-.53482-6.8914c-.14117-1.81903,1.22392-3.41384,3.04318-3.55503l9.68231-.75142c1.81904-.14117,3.41361,1.22393,3.55478,3.04297l.53482,6.8914c.14117,1.81903-1.22369,3.41382-3.04273,3.55499l-9.68231,.75142c-1.81926,.14119-3.41406-1.2239-3.55523-3.04294Z",
    fill: "#2369d1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M220.95121,194.56277l-1.97879-25.49742c-.14117-1.81904,1.22392-3.41383,3.04318-3.55502l14.33381-1.11241c1.81881-.14115,3.41361,1.22393,3.55478,3.04297l1.97879,25.49742c.14117,1.81904-1.22392,3.41383-3.04273,3.55499l-14.33381,1.11241c-1.81926,.14119-3.41406-1.2239-3.55523-3.04294Z",
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M253.2758,221.75286c-.66509,.61599-.99098,1.4867-.89406,2.38812l2.63711,24.58811c.15959,1.48515,1.45341,2.59941,2.94562,2.53661,.78465-.02936,1.49063-.3716,2.00664-.95363,.51646-.58206,.76779-1.33,.70758-2.10586l-1.8976-24.45128c-.09948-1.28189-1.05173-2.34039-2.31609-2.5745l-.74-.13725c-.25037-.04638-.50089-.05938-.74664-.04031-.62868,.04879-1.22419,.30705-1.70256,.74997Z",
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M213.95992,254.21969c-.69826-.57691-1.12164-1.39221-1.19172-2.29526l-1.8976-24.45128c-.11581-1.49221,.78956-2.88087,2.20148-3.37751l.70996-.24977c.99476-.34865,2.06917-.21268,2.94478,.37651,.8761,.58961,1.40716,1.53228,1.45788,2.58626l1.18761,24.7006c.08361,1.73691-1.20409,3.25121-2.93229,3.44702-.03987,.00447-.08026,.00806-.12023,.01116-.85808,.06659-1.69195-.19681-2.35986-.74773Z",
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M306.00566,262.16307l11.62002,17.36076,2.75658,20.32449,8.17089-.1147-4.66806-23.97122-18.55037-21.95795h0c-1.24336,2.71361-.98934,5.87808,.67094,8.35863Z",
    fill: "#ccc"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 286.44834,
    y: 295.54214,
    width: 33.24407,
    height: 0.46659,
    transform: "translate(-25.65735 28.80569) rotate(-5.22098)",
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 285.83179,
    y: 291.42255,
    width: 31.51854,
    height: 0.46656,
    transform: "translate(-23.74216 26.74341) rotate(-4.8853)",
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 285.25633,
    y: 287.47166,
    width: 30.15392,
    height: 0.46663,
    transform: "translate(-26.44697 30.43294) rotate(-5.55661)",
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 285.20626,
    y: 283.51125,
    width: 28.96796,
    height: 0.46681,
    transform: "translate(-29.49788 34.82609) rotate(-6.33939)",
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 284.65647,
    y: 279.86911,
    width: 27.83385,
    height: 0.46683,
    transform: "translate(-29.58073 35.32024) rotate(-6.45117)",
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 283.23489,
    y: 276.22887,
    width: 27.09311,
    height: 0.46655,
    transform: "translate(-20.50149 23.79224) rotate(-4.43769)",
    fill: "#3f3d56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 282.35878,
    y: 273.19741,
    width: 26.33203,
    height: 0.46658,
    transform: "translate(-23.1755 27.40351) rotate(-5.10909)",
    fill: "#3f3d56"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 281.5409,
    y: 270.28914,
    width: 25.52764,
    height: 0.46681,
    transform: "translate(-28.07086 34.15059) rotate(-6.33939)",
    fill: "#3f3d56"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 280.66811,
    y: 266.90855,
    width: 25.19798,
    height: 0.46662,
    transform: "translate(-24.02476 29.03214) rotate(-5.44474)",
    fill: "#3f3d56"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 279.63415,
    y: 263.94485,
    width: 24.1352,
    height: 0.46678,
    transform: "translate(-26.9362 33.20225) rotate(-6.2276)",
    fill: "#3f3d56"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 278.68156,
    y: 260.9123,
    width: 23.91178,
    height: 0.46658,
    transform: "translate(-21.64289 26.30919) rotate(-4.9972)",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M276.2032,252.27867l-2.44808-31.54437c-.14119-1.81926,1.2239-3.41406,3.04294-3.55523l15.26434-1.18463c1.81904-.14117,3.41361,1.22393,3.5548,3.0432l2.44808,31.54437c.14115,1.81881-1.22371,3.41359-3.04274,3.55476l-15.26434,1.18463c-1.81904,.14117-3.41383-1.22392-3.55499-3.04273Z",
    fill: "#2369d1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M244.22308,301.13031l-27.15409,.37585-.21868,.0028-1.62291-20.91178c-.20524-2.64463,1.77954-4.9634,4.42417-5.16865l26.68937-2.0713c2.64463-.20524,4.96295,1.77957,5.16819,4.42421l1.75761,22.64746-.23258,.01805-8.81109,.68335Z",
    fill: "#ccc"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M273.62358,194.92054l-1.87049-24.10197c-.14117-1.81904,1.22392-3.41383,3.04295-3.555l5.03103-.39045c1.81904-.14117,3.41361,1.22393,3.55478,3.04297l1.87049,24.10197c.14117,1.81904-1.22369,3.41382-3.04273,3.55499l-5.03103,.39045c-1.81904,.14117-3.41383-1.22392-3.555-3.04295Z",
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M286.93817,300.15554l-2.98381-20.35832-5.70252-19.21142-1.57802-5.25898h0c-2.51574-1.43949-5.59338,.61778-5.22509,3.49275l.291,2.27162,5.70252,19.21142,2.98381,20.35832",
    fill: "#ccc"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 51.17884,
    y: 300.55064,
    width: 425.38777,
    height: 0.93321,
    transform: "translate(-3.87966 3.44564) rotate(-.7427)",
    fill: "#ccc"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 193.28228,
    cy: 141.57095,
    r: 19.05092,
    fill: "#2369d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.64557,121.5008c-1.11224-.65057-2.80914-.31281-3.42047,.89685-2.41272,4.77405-4.17218,9.77136-5.31781,14.94482-1.82953-2.25513-3.659-4.51019-5.48846-6.76532-.85126-1.04932-2.65057-.88495-3.53552,0-1.03735,1.03735-.85339,2.48358,0,3.53552,2.91217,3.58972,5.82434,7.17944,8.73651,10.7691,.61505,.75812,1.90637,.87939,2.73102,.51697,.99493-.43738,1.40094-1.24561,1.5368-2.28473,.82538-6.31287,2.78607-12.51642,5.65479-18.19275,.60876-1.20453,.31793-2.70996-.89685-3.42047Z",
    fill: "#fff"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "c-96",
    d: "M203.76314,183.36398c8.55096,2.04129,16.53548-.71614,17.83366-6.15823,1.2982-5.44209-4.58109-11.5069-13.13538-13.54778-3.4059-.86212-6.96873-.89606-10.39044-.09895l-36.34-8.1915-3.48055,17.13522,36.19432,6.25613c2.69377,2.2572,5.88904,3.83629,9.31834,4.60509l.00002,.00002h.00002Z",
    fill: "#ffb6b6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M164.48021,88.85552l-6-5s-12,6-14,11-14,53.00001-14,53.00001c0,0-2.35432,26.30624,3.82283,29.65312s45.17717,1.34688,45.17717,1.34688l3-20-16-6-2-64.00001Z",
    fill: "#2369d1"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M403.784,368.94922c-.8443-1.42365-4.49683,.10068-5.16833-1.19135-.66913-1.28735,2.72449-3.24887,4.66333-7.7298,.34967-.80807,2.55298-5.90033,.92188-7.47162-3.09174-2.97836-17.23962,9.31259-22.19073,5.29041-1.08661-.88269-1.8457-2.64484-5.13428-5.50583-1.30829-1.13815-2.09937-1.65204-2.86499-1.46085-1.08636,.27127-1.17242,1.72522-2.33734,4.58398-1.74701,4.28729-2.78027,4.02841-3.79816,7.44897-.75562,2.53925-.58301,4.01553-1.47217,4.30313-1.25824,.40701-2.41638-2.28632-4.01099-2.04517-1.6272,.24612-2.61096,3.38205-2.92169,5.72998-.58313,4.40607,1.03497,7.31348,1.93182,10.37064,.97461,3.32236,1.55304,8.37494-.69769,15.52759l-22.27719,62.76614c4.91812-12.87943,19.15842-48.18536,25.14218-61.3053,1.72742-3.78745,3.6347-7.62909,7.55096-9.14526,3.77045-1.45978,8.94867-.58823,15.55029-2.17862,.771-.1857,2.91052-.73007,3.17981-1.98849,.22266-1.04037-1.03583-1.62109-.84247-2.59549,.25934-1.30701,2.73413-1.32306,5.77533-2.83096,2.14447-1.06332,3.48047-2.32785,4.62933-3.41531,.34637-.32785,5.49512-5.26166,4.37115-7.1568h-.00006Z",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.13889,401.99194c-.94235,.0036-1.24805,2.23611-2.07593,2.1929-.82492-.04303-.80847-2.2746-2.4483-4.5191-.29572-.40475-2.1593-2.95547-3.40115-2.60825-2.35385,.65808-.4035,11.14828-3.80618,12.41782-.74673,.27863-1.83066,.14276-4.18369,.93134-.9361,.31372-1.41656,.55371-1.54364,.98465-.1803,.61145,.50845,1.07324,1.57544,2.46979,1.60016,2.09445,1.17496,2.52692,2.56009,4.01343,1.02826,1.10352,1.80264,1.44476,1.68723,1.96414-.16327,.73499-1.81934,.52631-2.16107,1.37851-.34869,.86966,.90659,2.25729,1.9693,3.08725,1.99429,1.5575,3.88812,1.6022,5.64737,2.04413,1.91183,.48026,4.55859,1.65421,7.41974,4.82266l24.37836,29.04382c-4.90228-6.12997-18.12189-23.30609-22.83472-30.0285-1.3605-1.94061-2.69568-3.98517-2.30984-6.34479,.37143-2.27176,2.29327-4.56177,3.41748-8.26077,.13132-.43201,.48145-1.63916-.05847-2.13443-.44638-.40945-1.09451,.04068-1.51697-.33539-.56665-.50443,.13953-1.72369,.27689-3.6514,.09686-1.35931-.13831-2.37988-.34055-3.25754-.06097-.26459-.99695-4.21518-2.25137-4.21036v.00009Z",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.93851,406.21197l-.56775-5.06818,.2594-.38422c1.20035-1.77667,1.81216-3.51175,1.81949-5.15872,.00122-.26184-.01102-.52371-.02325-.79044-.04895-1.05719-.11011-2.37134,.5751-3.90329,.38422-.85406,1.46344-2.83142,3.08594-2.5867,.43683,.06119,.76721,.26184,1.01804,.49677,.03671-.05872,.07465-.11746,.11502-.18109,.50534-.77087,.90546-1.10123,1.29089-1.41937,.29611-.24472,.60202-.49677,1.08167-1.0939,.21045-.26184,.37442-.49188,.5127-.68521,.41971-.58487,.96786-1.28235,1.93451-1.27011,1.03271,.04895,1.57355,.90302,1.93207,1.46832,.63995,1.00824,.92993,1.73508,1.12204,2.21716,.06976,.17621,.14929,.37442,.18967,.43561,.33282,.48944,3.03824,.0318,4.05746-.13461,2.28937-.38177,4.27039-.71213,5.08655,.73172,.5849,1.03271,.15051,2.39825-1.33008,4.1676-.4613,.55063-.95197,.96909-1.38757,1.29703,.36096,.21536,.68396,.54572,.81494,1.06454h0c.30835,1.22849-.74762,2.45944-3.13733,3.66348-.59344,.30099-1.39246,.70236-2.51205,.89569-.52737,.09055-1.00214,.11258-1.40836,.12482-.00858,.23492-.06363,.48944-.20679,.75128-.41971,.77087-1.29333,1.13794-2.60995,1.04984-1.44876-.07587-2.64175-.35239-3.69406-.59467-.91891-.21045-1.7106-.3891-2.33218-.3475-1.15262,.09299-2.04099,1.01559-3.08347,2.21228l-2.6026,3.04187h-.00003Z",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.5722,376.0361l-4.75842,1.83472-.43744-.15347c-2.02304-.71045-3.85654-.86215-5.45151-.45148-.2536,.06525-.50378,.14349-.7587,.22299-1.01019,.31549-2.26587,.70801-3.92151,.43378-.92361-.155-3.11002-.69739-3.28485-2.32889-.05161-.43805,.05869-.80853,.22232-1.11075-.06613-.0206-.13257-.04239-.20435-.06531-.87384-.2933-1.29489-.59653-1.70041-.88867-.31183-.22437-.63324-.45633-1.33249-.76883-.30667-.13715-.57077-.2374-.79285-.32211-.67221-.2576-1.4859-.61096-1.71924-1.5491-.2146-1.01135,.47437-1.75113,.93024-2.24133,.81296-.87476,1.44244-1.33963,1.86005-1.64774,.15274-.11215,.32431-.23938,.37326-.29395,.38901-.44608-.73987-2.94693-1.15936-3.89062-.94998-2.11765-1.77203-3.95007-.5824-5.10577,.85059-.8277,2.28165-.75391,4.36868,.22946,.64963,.30655,1.17886,.67502,1.60657,1.01321,.11676-.40378,.35437-.80005,.82303-1.05829h0c1.11011-.60986,2.56863,.09933,4.33945,2.10547,.44168,.49768,1.03259,1.16876,1.50357,2.2027,.22134,.48715,.36307,.9408,.47797,1.33066,.22943-.0513,.48956-.06259,.77917,.00946,.85211,.21045,1.4288,.9624,1.67752,2.2583,.2941,1.42062,.32922,2.64474,.36179,3.72409,.02951,.94226,.0575,1.75336,.25543,2.34406,.38232,1.09134,1.50006,1.71661,2.92206,2.42148l3.60254,1.74591-.00012,.00003Z",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.93851,361.1051l-.56775-5.06818,.2594-.38422c1.20035-1.77667,1.81216-3.51175,1.81949-5.15872,.00122-.26184-.01102-.52371-.02325-.79044-.04895-1.05719-.11011-2.37134,.5751-3.90329,.38422-.85406,1.46344-2.83142,3.08594-2.5867,.43683,.06119,.76721,.26184,1.01804,.49677,.03671-.05872,.07465-.11746,.11502-.18109,.50534-.77087,.90546-1.10123,1.29089-1.41937,.29611-.24472,.60202-.49677,1.08167-1.0939,.21045-.26184,.37442-.49188,.5127-.68521,.41971-.58487,.96786-1.28235,1.93451-1.27011,1.03271,.04895,1.57355,.90302,1.93207,1.46832,.63995,1.00824,.92993,1.73508,1.12204,2.21716,.06976,.17621,.14929,.37442,.18967,.43561,.33282,.48944,3.03824,.0318,4.05746-.13461,2.28937-.38177,4.27039-.71213,5.08655,.73172,.5849,1.03271,.15051,2.39825-1.33008,4.1676-.4613,.55063-.95197,.96909-1.38757,1.29703,.36096,.21536,.68396,.54572,.81494,1.06454h0c.30835,1.22849-.74762,2.45944-3.13733,3.66348-.59344,.30099-1.39246,.70236-2.51205,.89569-.52737,.09055-1.00214,.11258-1.40836,.12482-.00858,.23492-.06363,.48944-.20679,.75128-.41971,.77087-1.29333,1.13794-2.60995,1.04984-1.44876-.07587-2.64175-.35239-3.69406-.59467-.91891-.21045-1.7106-.3891-2.33218-.3475-1.15262,.09299-2.04099,1.01559-3.08347,2.21228l-2.6026,3.04187h-.00003Z",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.12415,459.48285l-1.0621-.66565-.25696-1.22604,.25696,1.22604-1.23828,.14194c-.01959-.11502-.08688-.37933-.18842-.79291-.55429-2.26611-2.24408-9.16235-3.65369-20.02304-.9838-7.58145-1.54053-15.37579-1.65555-23.17017-.11502-7.80658,.25452-13.71661,.55063-18.46661,.22391-3.5827,.49557-6.99411,.7623-10.31744,.70969-8.87848,1.379-17.26505,.88098-26.54974-.11011-2.07278-.3414-6.38721-2.862-10.97818-1.46222-2.66257-3.47626-5.02655-5.98709-7.02347l1.56131-1.96265c2.77145,2.20737,4.99963,4.8259,6.62338,7.78214,2.79471,5.09018,3.04678,9.79129,3.16791,12.05005,.50656,9.44867-.17007,17.91602-.88712,26.88013-.26431,3.31107-.53595,6.70779-.75864,10.27582-.29367,4.70599-.65952,10.56458-.54572,18.27084,.11258,7.70135,.66318,15.40027,1.63351,22.88629,1.39246,10.72366,3.0578,17.51712,3.60474,19.74896,.29123,1.1918,.35239,1.44141,.05383,1.91373v-.00003Z",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.07507,345.6192c-.10278,0-.20679-.00244-.31201-.0098-2.13397-.11502-4.11008-1.39246-5.87451-3.79562-.82715-1.13062-1.25052-2.42029-2.09482-4.99231-.13092-.39645-.76721-2.40805-1.15387-5.17584-.2533-1.8085-.22147-2.56467,.13705-3.23276,.39767-.74396,1.04129-1.26276,1.76566-1.6127-.0318-.23984-.00613-.487,.0979-.73907,.42703-1.04495,1.56253-.9079,2.17679-.84183,.31079,.03915,.69867,.09055,1.11716,.06851,.65829-.0318,1.01193-.2276,1.54785-.52127,.5127-.28143,1.15018-.63138,2.09604-.82471,1.86478-.3891,3.42731,.1395,3.94244,.31323,2.71027,.90302,4.04645,3.01007,5.59308,5.44992,.30835,.48944,1.36676,2.271,2.06543,4.71332,.50412,1.76199,.43317,2.5451,.28143,3.12753-.30835,1.19669-1.03638,1.8819-2.88525,3.39429-1.93085,1.58334-2.89993,2.37625-3.73199,2.85834-1.93695,1.11838-3.15323,1.82071-4.76837,1.82071v.00006Z",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M428.04004,458.34338h0c0,.46393-.3761,.84003-.84003,.84003H.84003c-.46393,0-.84003-.3761-.84003-.84003H0c0-.46393,.37609-.84003,.84003-.84003H427.20001c.46393,0,.84003,.3761,.84003,.84003Z",
    fill: "#e6e6e6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseGuy);
export default __webpack_public_path__ + "static/media/house_guy.ce218d9e77fc2d649d28a48b4dd4fe40.svg";
export { ForwardRef as ReactComponent };